import { render } from "./ClientSMSAndEmailSetting.vue?vue&type=template&id=2539ab04&scoped=true"
import script from "./ClientSMSAndEmailSetting.vue?vue&type=script&lang=js"
export * from "./ClientSMSAndEmailSetting.vue?vue&type=script&lang=js"

import "./ClientSMSAndEmailSetting.vue?vue&type=style&index=0&id=2539ab04&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2539ab04"]])

export default __exports__